import { gtm } from 'apps/gtm';
import { pageEventTypes, wa } from 'apps/analytics';

const pageEvents = {
  PRODUCT_ADDED_TO_NEW_LIST: 'Item Added to new List',
  PRODUCT_ADDED_TO_EXISTING_LIST: 'Item Added to List',
  BASKET_ADDED_TO_NEW_LIST: 'Trolley Added to new List',
  BASKET_ADDED_TO_EXISTING_LIST: 'Trolley Added to List',
};

const SOURCE_OF_CHANGE = {
  ADD_PRODUCT_TO_NEW_LIST: {
    event: pageEvents.PRODUCT_ADDED_TO_NEW_LIST,
    gtmSource: 'From Front of Pack',
    waSource: 'Front of Pack',
  },
  ADD_PRODUCT_TO_EXISTING_LIST: {
    event: pageEvents.PRODUCT_ADDED_TO_EXISTING_LIST,
    gtmSource: 'From Front of Pack',
    waSource: 'Front of Pack',
  },
  ADD_BASKET_TO_NEW_LIST: {
    event: pageEvents.BASKET_ADDED_TO_NEW_LIST,
    gtmSource: 'From Mobile Trolley',
    waSource: 'Mobile Trolley',
  },
  ADD_BASKET_TO_EXISTING_LIST: {
    event: pageEvents.BASKET_ADDED_TO_EXISTING_LIST,
    gtmSource: 'From Mobile Trolley',
    waSource: 'Mobile Trolley',
  },
};

function trackItemAddedToShoppingList(sku, sourceOfChange) {
  gtm.trigger('gtm:uaEvent', {
    category: 'Shopping List',
    action: sourceOfChange.event,
    label: sourceOfChange.gtmSource,
  });
  wa.triggerPageEventWithDescription(sourceOfChange.event, {
    SOURCE: sourceOfChange.waSource,
    SKU: sku,
  });
}

export function reportShoppingListCreated() {
  gtm.trigger('gtm:uaEvent', {
    category: 'Shopping List',
    action: 'New List Created',
  });
  wa.triggerPageEvent(pageEventTypes.QM_CREATE_SHOPPING_LIST);
}

export function reportItemAddedToNewShoppingList(sku) {
  trackItemAddedToShoppingList(sku, SOURCE_OF_CHANGE.ADD_PRODUCT_TO_NEW_LIST);
}

export function reportItemAddedToExistingShoppingList(sku) {
  trackItemAddedToShoppingList(sku, SOURCE_OF_CHANGE.ADD_PRODUCT_TO_EXISTING_LIST);
}

function reportBasketItemAddedToNewShoppingList(sku) {
  trackItemAddedToShoppingList(sku, SOURCE_OF_CHANGE.ADD_BASKET_TO_NEW_LIST);
}

function reportBasketItemAddedToExistingShoppingList(sku) {
  trackItemAddedToShoppingList(sku, SOURCE_OF_CHANGE.ADD_BASKET_TO_EXISTING_LIST);
}

export function reportBasketAddedToNewShoppingList(basket) {
  basket.items.forEach(item => reportBasketItemAddedToNewShoppingList(item.sku));
}

export function reportBasketAddedToExistingShoppingList(basket) {
  basket.items.forEach(item => reportBasketItemAddedToExistingShoppingList(item.sku));
}
